import {combineReducers} from "redux";
import {networkReducer} from "./networkReducer";
import {deviceReducer} from "./deviceReducer";
import {userReducer} from "./userReducer";
import {routerReducer} from 'react-router-redux';
import {alertReducer} from "./alertReducer";
import {appReducer} from "./appReducer";

export const rootReducer = combineReducers({
    network: networkReducer,
    device: deviceReducer,
    user: userReducer,
    alert: alertReducer,
    app: appReducer,
    router: routerReducer
});


// WEBPACK FOOTER //
// ./src/state/reducer/rootReducer.js